import React from 'react'
import { useWeb3React } from '@web3-react/core'
import { ConnectWallet } from 'src/components/ConnectWallet'
import { LevelDashboard } from '../../components/LevelDashboard'
import './ProfilePage.scss'

export function ProfilePage() {
  const { account } = useWeb3React()
  if (!account) {
    return <ConnectWallet />
  }
  return (
    <div className="level-dashboard-page page">
      <div className="level-dashboard__content">
        <LevelDashboard account={account} />
      </div>
    </div>
  )
}
